import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareFormSubmitPublicRoute: InvariantJiraRoute = {
	name: 'software-form-submit-public',
	path: '/jira/software/form/:formUuid',
	exact: true,
};
